import { Alarm as Clock } from "@phosphor-icons/react";

export default Clock
